import { NgModule } from "@angular/core";
import { VenueInlineAddressPipe } from "../pipe/venue-inline-address.pipe";
import { SportFormatSurfaceTextPipe } from "../pipe/sport-format-surface-text.pipe";
import { SportToPitchCourtTextPipe } from "../pipe/sport-to-pitch-court-text.pipe";
import { NewLinePipe } from "../pipe/newLine.pipe";
import { DateFnsPipe } from "../pipe/date-fns.pipe";
import { DifferenceInMinutesFnsPipe } from "../pipe/differenceInMinutes-fns.pipe";
import { MomentTimezonePipeModule } from "../shared/module/pipe/moment-timezone-pipe.module";
import { RemoveSpacersPipe } from "./../pipe/remove.spacers.pipe";
import { MinutesToTextPipeModule } from "../shared/module/pipe/minutes-to-text-pipe.module";

@NgModule({
    imports: [MomentTimezonePipeModule, MinutesToTextPipeModule],
    exports: [
        NewLinePipe,
        SportToPitchCourtTextPipe,
        SportFormatSurfaceTextPipe,
        VenueInlineAddressPipe,
        DateFnsPipe,
        DifferenceInMinutesFnsPipe,
        RemoveSpacersPipe,
    ],
    declarations: [
        NewLinePipe,
        SportToPitchCourtTextPipe,
        SportFormatSurfaceTextPipe,
        VenueInlineAddressPipe,
        DateFnsPipe,
        DifferenceInMinutesFnsPipe,
        RemoveSpacersPipe,
    ],
})
export class VenuePipeModule {}
